import { FC } from 'react';
import { TableStyled } from './style';

const Table: FC<{ children?: any }> = ({ children, ...restProps }) => (
  <TableStyled {...restProps}>{children}</TableStyled>
);

export default Table;
